import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ScheduleAMeeting from './scheduleAMeeting';
import {
  getPocList,
  createMeeting,
  getMeetingById,
  updateMeeting,
} from 'services/redux/brandActivtion/meetings/action';
import { getCorpPocList } from 'services/redux/brandActivtion/corporateClient/action';
import { getCorpClientList } from 'services/redux/brandActivtion/corporateClient/action';

const mapStateToProps = (state) => ({
  pocList: state.baMeetingReducer.pocList,
  meetingById: state.baMeetingReducer.meetingById,
  corpClientList: state.CorpClientReducer.corpClientList,
  corpClientPoc: state.CorpClientReducer.corpClientPoc,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPocList,
      createMeeting,
      getMeetingById,
      updateMeeting,
      getCorpClientList,
      getCorpPocList,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleAMeeting);
